import styled from 'styled-components';

export const Card = styled.div`
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.inputBorder};
  padding: 24px;
`;
export const Title = styled.h5`
  font-size: 24px;
  color: ${({ theme }) => theme.primaryDark};
  margin-bottom: 24px;
  font-weight: 500;
`;
export const UploadedImageWrap = styled.div`
  display: flex;
  margin: 0 -5px;
  @media only screen and (min-width: 768px) and (max-width: 1099px) {
    flex-wrap: wrap;
  }
  @media (max-width: 1099px) {
    flex-wrap: wrap;
    gap: 8px;
  }
`;
export const UploadedImage = styled.div`
  padding: 0 5px;
  width: 20%;
  min-width: 200px;
  height: 100%;
  @media only screen and (min-width: 768px) and (max-width: 1099px) {
    min-width: 196px;
  }
  @media (max-width: 767px) {
    width: 48%;
    height: 150px;
    min-width: initial;
  }
`;
export const UploaderBox = styled.div`
  padding: 0 5px;
  width: 20%;
  min-width: 200px;
  height: 100%;
  @media (max-width: 767px) {
    width: 100%;
    min-width: initial;
  }
  > div {
    width: 100%;
    display: block;
    .file-upload {
      height: 200px;
      cursor: pointer;
      min-height: 200px;
      max-width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0;
      svg {
        width: 48px;
        height: 48px;
      }
      p {
        font-size: 14px;
      }
    }
  }
`;
export const UploadedImageBox = styled.div`
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  :hover {
    div {
      display: flex;
    }
  }
  > svg {
    position: absolute;
    right: 0;
    top: 0;
    width: 54px;
    height: 54px;
    border-radius: 0px 0px 0px 12px;
    padding: 15px;
    color: ${({ theme }) => theme.primary};
    background-color: ${({ theme }) => theme.white};
    @media (max-width: 767px) {
      z-index: 10;
    }
  }
  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 4px;
    @media (max-width: 767px) {
      height: 150px;
      aspect-ratio: 1/1;
    }
  }
`;
export const UploadedCover = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 150px;
  display: none;
  align-items: flex-end;
  z-index: 9;
  color: ${({ theme }) => theme.white};
  width: 100%;
  padding: 10px;
  @media (max-width: 767px) {
    display: flex;
  }
  svg {
    vertical-align: middle;
  }
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    background: linear-gradient(
      360deg,
      #828282 0%,
      rgba(255, 255, 255, 0) 58.12%
    );
    z-index: -1;
    @media (max-width: 767px) {
      background: linear-gradient(
        360deg,
        #828282 0%,
        rgba(255, 255, 255, 0) 30%
      );
    }
  }
`;
export const UploadedCoverText = styled.div`
  svg {
    vertical-align: -6px;
    width: 24px;
    margin-right: 5px;
    height: 24px;
    stroke: ${({ theme }) => theme.primary};
    path {
      fill: ${({ starred, theme }) =>
        starred ? theme.primary : 'transparent'};
    }
  }
`;
export const UploadProgressBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 20%;
  height: 200px;
  border: 1px solid ${({ theme }) => theme.borderColorLight};
  border-radius: 4px;
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    width: 32%;
    min-width: 196px;
  }
  @media (max-width: 767px) {
    width: 48%;
    height: 150px;
  }
  h5 {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    margin-top: 13px;
    margin-bottom: 14px;
  }
  button {
    font-weight: 600;
  }
`;

export const SellingItemStyle = {
  Card,
  Title,
  UploadedImage,
  UploadedImageWrap,
  UploaderBox,
  UploadedImageBox,
  UploadedCover,
  UploadedCoverText,
  UploadProgressBox,
};
